export const contactsData = {
    email: 'lovkashgarg@gmail.com',
    phone: '+919896316033',
    address: 'Pune,Maharastra',
    sheetAPI: 'https://portfolio-back-ysfh.onrender.com/api/contact'
}
